import { FaStar, FaStarHalfAlt } from "react-icons/fa";
import { TrainerData } from "../types/TrainerInfo";

const AdminTrainerCard = ({ Trainer }: { Trainer: TrainerData }) => {
    // Function to render stars based on float rating
    const renderStars = (rating: number) => {
        const fullStars = Math.floor(rating); // Full stars
        const hasHalfStar = rating % 1 >= 0.5; // Check if we need a half star
        const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0); // Remaining empty stars

        return (
            <div className="flex space-x-1">
                {/* Full Stars */}
                {Array(fullStars)
                    .fill(0)
                    .map((_, i) => (
                        <FaStar key={`full-${i}`} className="text-yellow-300" />
                    ))}
                {/* Half Star */}
                {hasHalfStar && (
                    <FaStarHalfAlt key="half" className="text-yellow-300" />
                )}
                {/* Empty Stars */}
                {Array(emptyStars)
                    .fill(0)
                    .map((_, i) => (
                        <FaStar key={`empty-${i}`} className="text-gray-300" />
                    ))}
            </div>
        );
    };

    return (
        <div className="bg-white shadow-lg rounded-xl p-4 border border-gray-200 w-64 text-center my-5">
            {/* Profile Image */}
            <div className="relative -mt-10 flex justify-center">
                <div className="w-16 h-16 rounded-full border-4 border-white bg-purple-300 flex items-center justify-center">
                    <img
                        src={Trainer.profileImage}
                        alt="Tutor"
                        className="w-full h-full rounded-full"
                    />
                </div>
            </div>

            {/* Name */}
            <h2 className="text-lg font-semibold text-gray-900 mt-2">{Trainer.name}</h2>

            {/* Specialization */}
            <p className="text-gray-500 text-sm">{Trainer.trainerInfo.category} {Trainer.trainerInfo.subCategory}</p>

            {/* Rating */}
            <div className="flex justify-center items-center space-x-1 text-yellow-400 my-2">
                <span className="text-gray-400 text-sm">{Trainer.trainerInfo.numOfOrders}</span>
                {renderStars(Trainer.trainerInfo.rate)}
            </div>

            {/* Price */}
            <div className="bg-gray-100 text-primary-100 font-semibold py-2 rounded-md w-full">
                جنية {Trainer.trainerInfo.priceOfLesson}
            </div>
        </div>
    );
};

export default AdminTrainerCard;